import { combineReducers } from "redux";
import loaderReducer from "./loaderReducer";
import profileReducer from "./profileReducer";
import toastReducer from "./toastReducer";
import dashboardReducer from "./dashboardReducer";
import usersReducer from "./userReducer";
import uploadReducer from "./uploadReducer";
import servicesReducer from "./serviceReducer";
import ordersReducer from "./orderReducer";
import styleGuideReducer from "./styleGuideReducer";
import ourWorkReducer from "./ourWorkReducer";
import contentReducer from "./contentReducer";
import contactsReducer from "./contactReducer";
import enquiriesReducer from "./enquiriesReducer";
import ourClientReducer from "./ourClientReducer";

export default combineReducers({
    toast: toastReducer,
    loader: loaderReducer,
    profile: profileReducer,
    dashboard: dashboardReducer,
    user: usersReducer,
    upload: uploadReducer,
    service: servicesReducer,
    order: ordersReducer,
    style: styleGuideReducer,
    work: ourWorkReducer,
    content: contentReducer,
    contact: contactsReducer,
    enquiry: enquiriesReducer,
    ourClient: ourClientReducer,
});
